<template>
  <section class="w1312 main-content-wrap">
    <div class="notice-list-page">
      <div class="page-header">
        <h2>公告列表</h2>
      </div>

      <!-- 查询栏 -->
      <div class="search-bar">
        <div class="search-row">
          <div class="search-item">
            <label>标题</label>
            <t-input v-model="searchTitle" placeholder="请输入标题关键词" clearable style="width: 240px;" />
          </div>
          <div class="search-item">
            <label>发布时间</label>
            <t-date-range-picker
              v-model="dateRange"
              placeholder="请选择时间范围"
              style="width: 280px;"
              clearable
            />
          </div>
          <div class="search-actions">
            <button class="btn-search" @click="handleSearch">查询</button>
            <t-button theme="default" @click="handleReset">重置</t-button>
          </div>
        </div>
      </div>

      <!-- 列表 -->
      <div class="notice-table-wrap">
        <div class="loading-wrapper" v-if="loading">
          <i class="loading-icon"></i>
        </div>
        <template v-else>
          <template v-if="error">
            <div class="state-placeholder error" @click="loadData">
              <span>加载失败，点击重试</span>
            </div>
          </template>
          <template v-else-if="noticePageList.length === 0">
            <div class="state-placeholder empty">
              <span>暂无公告</span>
            </div>
          </template>
          <template v-else>
            <ul class="notice-items">
              <li
                v-for="item in noticePageList"
                :key="item.noticeId"
                class="notice-row"
                @click="goDetail(item.noticeId)"
              >
                <span class="notice-item-title">{{item.title}}</span>
                <span class="notice-item-time">{{formatDate(item.publishTime)}}</span>
              </li>
            </ul>
            <div class="pagination-wrap" v-if="noticePageTotal > pageModal.pageSize">
              <pagination v-model:pageModal="pageModal" @query="loadData()" :pageSizeList="[10, 20, 50]"/>
            </div>
          </template>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import pagination from '@/components/pagination.vue'

export default {
  name: 'NoticeList',
  data () {
    return {
      searchTitle: '',
      dateRange: [],
      pageNo: 1,
      pageSize: 10,
      pageModal: { pageNo: 1, pageSize: 10, total: 0 },
      loading: false,
      error: false
    }
  },
  computed: {
    ...mapState(['noticePageList', 'noticePageTotal', 'sessionTarget', 'queryUserPromise'])
  },
  mounted () {
    this.queryUserPromise && this.queryUserPromise.then(() => {
      this.loadData()
    })
  },
  watch: {
    noticePageTotal (val) {
      this.pageModal.total = val || 0
    }
  },
  components: { pagination },
  methods: {
    ...mapActions(['queryNoticeList']),
    loadData () {
      this.loading = true
      this.error = false
      const startTime = this.dateRange && this.dateRange[0] ? new Date(this.dateRange[0]).getTime() : undefined
      const endTime = this.dateRange && this.dateRange[1] ? new Date(this.dateRange[1]).getTime() + 86400000 - 1 : undefined

      this.queryNoticeList({
        pageNo: this.pageModal.pageNo,
        pageSize: this.pageModal.pageSize,
        title: this.searchTitle || undefined,
        startTime,
        endTime
      }).catch(() => {
        this.error = true
      }).finally(() => {
        this.loading = false
      })
    },
    handleSearch () {
      this.pageModal.pageNo = 1
      this.loadData()
    },
    handleReset () {
      this.searchTitle = ''
      this.dateRange = []
      this.pageModal.pageNo = 1
      this.loadData()
    },
    goDetail (noticeId) {
      if (!noticeId) return
      this.$router.push({
        name: 'NoticeInfo',
        params: {
          target: this.sessionTarget,
          id: noticeId
        }
      })
    },
    formatDate (timeStr) {
      if (!timeStr) return ''
      const date = new Date(timeStr)
      const pad = (n) => String(n).padStart(2, '0')
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
    }
  }
}
</script>

<style lang="scss" scoped>
.notice-list-page {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  min-height: 500px;
  margin-top: 20px;
  margin-bottom: 40px;

  .page-header {
    margin-bottom: 20px;
    h2 {
      font-size: 20px;
      font-weight: 600;
      color: #333;
      margin: 0;
    }
  }

  .search-bar {
    background: #F7F8FA;
    border-radius: 8px;
    padding: 16px 20px;
    margin-bottom: 20px;

    :deep(.t-input) {
      &:hover {
        border-color: #F32B80;
      }
      &:focus-within {
        border-color: #F32B80;
        box-shadow: 0 0 0 2px rgba(243, 43, 128, 0.1);
        outline: none;
      }
    }
    :deep(.t-input__wrap) {
      &:focus-visible {
        outline: none;
      }
    }
    :deep(.t-date-range-picker) {
      &.t-is-focused {
        .t-input {
          border-color: #F32B80;
          box-shadow: 0 0 0 2px rgba(243, 43, 128, 0.1);
        }
      }
    }
    :deep(.t-range-input) {
      &:hover {
        border-color: #F32B80;
      }
      &:focus-visible {
        outline: none;
      }
    }
    :deep(.t-range-input-popup--visible) {
      .t-range-input {
        border-color: #F32B80;
      }
    }
    :deep(.t-range-input-popup) {
      &:focus-visible {
        outline: none;
      }
    }

    .search-row {
      display: flex;
      align-items: center;
      gap: 16px;
      flex-wrap: wrap;

      .search-item {
        display: flex;
        align-items: center;
        gap: 8px;

        label {
          font-size: 14px;
          color: #666;
          white-space: nowrap;
        }
      }

      .search-actions {
        display: flex;
        gap: 8px;
        .btn-search {
          background: #F32B80;
          border: 1px solid #CD2A78;
          border-radius: 3px;
          color: #fff;
          font-size: 14px;
          padding: 0 24px;
          height: 32px;
          line-height: 32px;
          cursor: pointer;
          outline: none;
          transition: transform 0.1s;
          &:hover {
            opacity: 0.85;
          }
          &:active {
            transform: scale(0.95);
          }
        }
      }
    }
  }

  .notice-table-wrap {
    .loading-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 260px;
      .loading-icon {
        display: inline-block;
        background: url(~@/assets/img/loading.gif) no-repeat;
        background-size: 100%;
        width: 50px;
        height: 50px;
      }
    }
    .notice-items {
      list-style: none;
      margin: 0;
      padding: 0;

      .notice-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 14px 16px;
        border-bottom: 1px solid #F0F0F0;
        cursor: pointer;
        transition: background 0.15s;

        &:hover {
          background: #F7F8FA;
        }

        .notice-item-title {
          font-size: 15px;
          color: #333;
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-right: 16px;
        }

        .notice-item-time {
          font-size: 13px;
          color: #999;
          white-space: nowrap;
        }
      }
    }

    .state-placeholder {
      text-align: center;
      padding: 60px 0;
      font-size: 14px;
      color: #999;

      &.error {
        color: #FD3374;
        cursor: pointer;
      }
    }

    .pagination-wrap {
      display: flex;
      justify-content: center;
      padding: 20px 0;
    }
  }
}
</style>
